import { Link } from 'react-router-dom'
import type { Session } from '../types'

interface Props {
  session: Session
}

export function SessionCard({ session }: Props) {
  const delta = session.emotion_intensity_post !== null
    ? session.emotion_intensity_post - session.emotion_intensity_pre
    : null

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr)
    const now = new Date()
    const diff = now.getTime() - date.getTime()
    const days = Math.floor(diff / (1000 * 60 * 60 * 24))

    if (days === 0) return 'Today'
    if (days === 1) return 'Yesterday'
    if (days < 7) return `${days} days ago`
    return date.toLocaleDateString()
  }

  return (
    <Link to={`/session/${session.id}`} className="session-card">
      <div className="session-card-header">
        <span className="session-emotion">{session.emotion_label}</span>
        <span className="session-date">{formatDate(session.created_at)}</span>
      </div>

      <p className="session-trigger">{session.trigger_text}</p>

      <div className="session-intensity">
        <div className="intensity-comparison">
          <div className="intensity-item">
            <span className="intensity-label">Before</span>
            <div className="intensity-bar">
              <div
                className="intensity-fill intensity-pre"
                style={{ width: `${session.emotion_intensity_pre * 10}%` }}
              />
            </div>
            <span className="intensity-value">{session.emotion_intensity_pre}</span>
          </div>
          {session.emotion_intensity_post !== null && (
            <div className="intensity-item">
              <span className="intensity-label">After</span>
              <div className="intensity-bar">
                <div
                  className="intensity-fill intensity-post"
                  style={{ width: `${session.emotion_intensity_post * 10}%` }}
                />
              </div>
              <span className="intensity-value">{session.emotion_intensity_post}</span>
            </div>
          )}
        </div>
        {delta !== null && (
          <span className={`session-delta ${delta < 0 ? 'improved' : delta > 0 ? 'worsened' : ''}`}>
            {delta < 0 ? `${delta}` : delta > 0 ? `+${delta}` : 'No change'}
          </span>
        )}
      </div>

      {session.distortions.length > 0 && (
        <div className="session-chips">
          {session.distortions.slice(0, 3).map(d => (
            <span key={d} className="chip">{d}</span>
          ))}
          {session.distortions.length > 3 && (
            <span className="chip chip-more">+{session.distortions.length - 3}</span>
          )}
        </div>
      )}
    </Link>
  )
}
